<template>

        <div class="cheetah-turbo-page container">
          <template v-if="website.id">
          <div class="header-container d-flex justify-content-between align-items-center">
            <div class="cheetah-turbo-page__header">
              <h1 v-text="website.title ? website.title : $t('ct-website-name-here')" />
            </div>
          </div>
          <div class="body-container" >
            <form v-if="website">
              <div class="card">
                <div class="card-header d-flex align-items-center justify-content-between">
                  {{ $t('ct-cheetah-turbo-page') }}
                  <button
                    type="button"
                    @click.prevent="saveSettings(website)"
                    class="cheetah-button cheetah-button-size-small cheetah-button-color-success"
                  >
                    <i class="svg-icon svgi-save" />
                    {{ $t('ct-save')}}
                  </button>
                </div>

                <!-- Theme -->
                <div class="card-body cheetah-turbo-page__content">
                  <div class="col-md-12">
                    <h2
                      class="card-title"
                      v-text="$t('ct-theme')"
                    />
                    <div class="form-group d-flex cheetah-turbo-page__content_themes row">
                      <div :class="`col-md-4 ${theme.theme === 1 ? 'active' : ''}`" @click="theme.theme = 1" />
                      <div :class="`col-md-4 ${theme.theme === 2 ? 'active' : ''}`" @click="theme.theme = 2" />
                      <div :class="`col-md-4 ${theme.theme === 4 ? 'active' : ''}`" @click="theme.theme = 4" />
                      <div :class="`col-md-4 ${theme.theme === 5 ? 'active' : ''}`" @click="theme.theme = 5" />
                      <div :class="`col-md-4 ${theme.theme === 6 ? 'active' : ''}`" @click="theme.theme = 6" />
                      <!-- <div :class="`col-md-4 ${theme.theme === 3 ? 'active' : ''}`" @click="theme.theme = 3" /> -->
                    </div>
                  </div>
                </div>
                <!-- Theme -->

                <!-- General Settings -->
                <div class="card-body cheetah-turbo-page__content cheetah-turbo-page__separator">
                  <div class="col-md-12">
                    <h2
                      class="card-title"
                      v-text="$t('ct-general-settings')"
                    />


                  </div>
                  <div class="row">


                    <div class="col-md-5">
                      <div class="form-group">
                        <label
                          for="title"
                          v-text="$t('ct-title') + ' *'"
                        />
                        <input
                          type="text"
                          id="title"
                          maxlength="60"
                          class="form-control"
                          required
                          v-model="general_settings.title"
                        />
                      </div>
                    </div>
                    <div class="col-md-5">

                        <div class="form-group">
                        <label for="url">URL *</label>
                        <input
                          type="text"
                          id="url"
                          class="form-control"
                          required
                          v-model="general_settings.url"
                        />
                      </div>

                    </div>

                      <div class="col-md-2">

                        <div class="form-group">
                        <label for="initial">{{ $t('ct-initial') }}</label>
                        <select v-model="general_settings.initial" id="" class="form-control">
                          <option :value="'0'">{{ $t('ct-no') }}</option>
                          <option :value="'1'">{{ $t('ct-yes') }}</option>
                        </select>
                      </div>

                    </div>

                  </div>


                </div>
                <!-- General Settings -->

                <!-- SEO Settings -->
                <div v-show="1 == 2" class="card-body cheetah-turbo-page__content cheetah-turbo-page__separator">
                  <div class="col-md-6">
                    <h2
                      class="card-title"
                      v-text="$t('ct-seo-settings')"
                    />
                     </div>

                     <div class="row">
                       <div class="col-md-6">


                          <div class="form-group">
                            <label for="facebook">Facebook</label>
                            <input
                              type="text"
                              id="facebook"
                              class="form-control"
                              placeholder="Pixel ID - exemplo: 1484257648798990"
                              v-model="seo.facebook_pixel"
                            />
                          </div>

                          <div class="form-group">
                            <label for="google_tag_manager">Google TAG Manager</label>
                            <input
                              type="text"
                              id="google_tag_manager"
                              class="form-control"
                              placeholder="Pixel ID - exemplo: GTM-PR97GW6"
                               v-model="seo.google_tag_manager"
                            />
                          </div>
                       </div>
                       <div class="col-md-6">


                          <div class="form-group">
                            <label for="google_analytics">Google Analytics</label>

                            <input
                              type="text"
                              id="google_analytics"
                              class="form-control"
                              placeholder="Pixel ID - exemplo: G-ABC123XYZ"
                               v-model="seo.google_analytics"
                            />
                          </div>


                          <div class="form-group">
                            <label
                              for="keyword"
                              v-text="$t('ct-key-word')"
                            />
                            <input
                              type="text"
                              id="keyword"
                              maxlength="140"
                              class="form-control"
                               v-model="seo.keywords"
                            />
                          </div>

                       </div>

                       <div class="col-md-12">
                        <div class="form-group">
                          <label
                            for="metatag"
                            v-text="$t('ct-metatag')"
                          />
                          <textarea
                            type="text"
                            id="metatag"
                            class="form-control"
                            v-model="seo.metatag"
                            rows="4"
                          />
                        </div>

                       </div>
                     </div>


                </div>
                <!-- SEO Settings -->

                <!-- Content Settings -->
                <div class="card-body cheetah-turbo-page__content cheetah-turbo-page__separator">
                  <div class="col-md-6">
                    <h2
                      class="card-title"
                      v-text="$t('ct-content-settings')"
                    />

                    </div>

                    <div class="row">

                      <div class="col-md-6">
                        <div class="form-group">
                          <label
                            for="line_1"
                            v-text="$t('ct-line_1')"

                          />
                          <input
                            type="text"
                            id="line_1"
                            maxlength="140"
                            class="form-control"
                            v-model="content.line_1"

                          />
                        </div>
                        <div class="form-group">
                          <label
                            for="line_3"
                            v-text="$t('ct-line_3')"

                          />
                          <input
                            type="text"
                            id="line_3"
                            maxlength="140"
                            class="form-control"
                            v-model="content.line_3"

                          />
                        </div>

                        <div v-show="theme.theme == '1'" class="form-group">
                          <label
                            for="line_5"
                            v-text="$t('ct-line_5')"

                          />
                          <input
                            type="text"
                            id="line_5"
                            maxlength="140"
                            class="form-control"
                            v-model="content.line_5"

                          />
                        </div>

                         <div class="form-group">
                          <label
                            for="call_to_action_text"
                            v-text="$t('ct-call_to_action_text')"
                          />
                          <input
                            type="text"
                            id="line_4"
                            maxlength="140"
                            class="form-control"
                            v-model="content.call_to_action_text"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">

                         <div class="form-group">
                          <label
                            for="line_2"
                            v-text="$t('ct-line_2')"
                          />
                          <input
                            type="text"
                            id="line_2"
                            maxlength="140"
                            class="form-control"
                            v-model="content.line_2"
                          />
                        </div>

                         <div class="form-group">
                          <label
                            for="line_4"
                            v-text="$t('ct-line_4')"
                          />
                          <input
                            type="text"
                            id="line_4"
                            maxlength="140"
                            class="form-control"
                            v-model="content.line_4"
                          />
                        </div>

                         <div v-show="theme.theme == '1'"  class="form-group">
                          <label
                            for="line_6"
                            v-text="$t('ct-line_6')"
                          />
                          <input
                            type="text"
                            id="line_6"
                            maxlength="140"
                            class="form-control"
                            v-model="content.line_6"
                          />
                        </div>

                          <div class="form-group">
                            <label
                              for="call_to_action_page"
                              v-text="$t('ct-call_to_action_page')"
                            />
                            <input
                              type="text"
                              id="call_to_action_page"
                              maxlength="140"
                              v-model="content.call_to_action_page"
                              class="form-control"
                            />
                        </div>
                      </div>
                    </div>




                </div>
                <!-- Content Settings -->

                <!-- Footer Settings -->
                <div class="card-body cheetah-turbo-page__content cheetah-turbo-page__separator">
                  <div class="col-md-6">
                    <h2
                      class="card-title"
                      v-text="$t('ct-footer-settings')"
                    />
                  </div>

                  <div class="row">
                    <div class="col-md-12">

                    </div>
                    <div class="col-md-6">

                        <div class="form-group">
                        <label
                          for="email"
                          v-text="$t('ct-email')"
                        />
                        <input
                          type="text"
                          id="email"
                          maxlength="140"
                          class="form-control"
                          v-model="footer_settings.email"
                        />
                      </div>

                      <div class="form-group">
                        <label
                          for="terms-use-text"
                          v-text="$t('ct-terms-of-use-text')"
                        />
                        <input
                          type="text"
                          id="terms-use-text"
                          maxlength="140"
                          class="form-control"
                          v-model="footer_settings.terms_of_use_text"
                        />
                      </div>

                      <div class="form-group">
                        <label
                          for="privacy-policy-text"
                          v-text="$t('ct-privacy-policy-text')"
                        />
                        <input
                          type="text"
                          id="privacy-policy-text"
                          maxlength="30"
                          class="form-control"
                          v-model="footer_settings.privacy_policy_text"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">

                    <div class="form-group">
                        <label
                          for="company-data"
                          v-text="$t('ct-company-data')"
                        />
                        <input
                          type="text"
                          id="company-data"
                          maxlength="140"
                          class="form-control"
                          v-model="footer_settings.company_data"
                        />
                      </div>

                      <div class="form-group">
                        <label
                          for="terms-use-page"
                          v-text="$t('ct-terms-of-use-page')"
                        />
                        <input
                          type="text"
                          id="terms-use-page"
                          maxlength="140"
                          class="form-control"
                          v-model="footer_settings.terms_of_use_page"
                        />
                      </div>

                      <div class="form-group">
                        <label
                          for="privacy-policy-text"
                          v-text="$t('ct-privacy-policy-page')"
                        />
                        <input
                          type="text"
                          id="privacy-policy-text"
                          maxlength="140"
                          class="form-control"
                          v-model="footer_settings.privacy_policy_page"
                        />
                      </div>

                    </div>
                  </div>







                </div>
                <!-- Footer Settings -->

              </div>
            </form>
          </div>
          </template>
        </div>
</template>

<script>

import AlertBoxComponent from '../../commons/AlertBoxComponent';
import ToggleButtonComponent from '../../commons/ToggleButtonComponent';

import { storePage, getPage, updatePage } from '../../../js/services/editor/turbo';


import {
  get as getWebsite,
  editScripts
} from '../../../js/services/editor/website';
import Errors from '../../../js/base/Errors';

export default {
  name: 'CheetahTurboPage',
  components: {
    AlertBoxComponent,
    ToggleButtonComponent
  },
  data() {
    return {
      errors: new Errors(),
      edit: false,
      theme: {
        theme: 1
      },
      general_settings: {
        title: '',
        url: '',
        initial: '0',
      },
      seo: {
        keywords: '',
        metatag: '',
        facebook_pixel: '',
        google_analytics: '',
        google_tag_manager: ''
      },
      content: {
        line_1 : '',
        line_2 : '',
        line_3 : '',
        line_4 : '',
        line_5 : '',
        line_6 : '',
        call_to_action_text: '',
        call_to_action_page: '',
      },
      footer_settings: {
        email : '',
        company_data: '',
        terms_of_use_text: '',
        terms_of_use_page: '',
        privacy_policy_text: '',
        privacy_policy_page: '',
      },
      website: {},
    };
  },

  methods: {
    saveSettings(website) {

      this.general_settings.url = this.general_settings.url.replace(/[^a-zA-Z0-9-_]/g, '').toLowerCase();



      if(this.general_settings.title === '' || this.general_settings.url === ''){
         this.$snotify.error(
            'Need title & Url'
          );
          return
      }




      let obj = {
        website_id: website.encrypted_id,
        general_settings: this.general_settings,
        seo: this.seo,
        content: this.content,
        footer_settings: this.footer_settings,
        theme: this.theme.theme,
      }

      if(!this.edit) {
        storePage(obj)
          .then( res => {
            if(res.data.success) {
              this.$snotify.success(this.$t('ct-success-true'), {
                  position: 'centerTop'
                });

              getWebsite(this.$route.params.id)
                .then(data => {
                  this.$store.commit('website', data.data);
                })
                .catch(error => console.warn(error));

              setTimeout( () => {
                 this.$router.push({
                  name: 'SitePages',
                  params: { id: website.encrypted_id }
                });
              } ,2000)
            } else {
               this.$snotify.error(res.data.message, {
                position: 'centerTop'
              });
            }

          } )
      }else{
        updatePage(this.$route.params.page_id, obj)
        .then( res => {
            if(res.data.success) {
              this.$snotify.success(this.$t('ct-success-true'), {
                position: 'centerTop'
              });

              getWebsite(this.$route.params.id)
                .then(data => {
                  this.$store.commit('website', data.data);
                })
                .catch(error => console.warn(error));

            }else {
               this.$snotify.error(res.data.message, {
                position: 'centerTop'
              });
            }
        } )
      }

    },

    bindReturnValues(data){
      this.theme.theme = data.theme

      //general
      this.general_settings.title = data.page.title;
      this.general_settings.url = data.page.url;
      this.general_settings.initial = data.page.initial;


      //seo
      this.seo.keywords = data.props.keywords;
      this.seo.metatag = data.props.metatag;
      this.seo.facebook_pixel = data.props.facebook_pixel;
      this.seo.google_analytics = data.props.google_analytics;
      this.seo.google_tag_manager = data.props.google_tag_manager;

      //content
      this.content.line_1 = data.props.line_1;
      this.content.line_2 = data.props.line_2;
      this.content.line_3 = data.props.line_3;
      this.content.line_4 = data.props.line_4;
      this.content.line_5 = data.props.line_5;
      this.content.line_6 = data.props.line_6;
      this.content.call_to_action_text = data.props.call_to_action_text;
      this.content.call_to_action_page = data.props.call_to_action_page;


      //footer
      this.footer_settings.email = data.props.email;
      this.footer_settings.company_data = data.props.company_data;
      this.footer_settings.terms_of_use_text = data.props.terms_of_use_text;
      this.footer_settings.terms_of_use_page = data.props.terms_of_use_page;
      this.footer_settings.privacy_policy_text = data.props.privacy_policy_text;
      this.footer_settings.privacy_policy_page = data.props.privacy_policy_page;


      this.edit = true;
    }
  },

  async created() {
    this.$loading.show();

    getWebsite(this.$route.params.id)
      .then(website => {
        this.website = website.data;
        if(typeof this.$route.params.page_id !== 'undefined') {
          getPage(this.$route.params.page_id)
          .then( res => {
            this.bindReturnValues(res.data);

          } )
        }
      })
      .finally(() => this.$loading.hide());
  }
};
</script>

<style lang="scss" scoped>

.cheetah-turbo-page {
  &__header {
    h1 {
      font-family: 'Muli', sans-serif;
      font-size: 25px;
      font-weight: bold;

      color: #0080FC;
    }
  }

  &__content {
    h2 {
      font-family: 'Muli', sans-serif;
      font-size: 20px;
      font-weight: 600;

      color: #333333;

      margin: 25px 0px 22px 0px;
    }

    input {
      height: 46px;
    }

    textarea {
      resize: none;
    }

    &_themes {
      div {
        max-width: 350px;
        height: 190px;
        margin-left: 5px;
        margin-top: 15px;
        border: 2px solid;
        border-color: transparent;
        border-radius: 5px;

        background-position: center !important;

        transition: border-color 0.1s;

        cursor: pointer;

        &:nth-child(1) {
          background: url('../../../assets/images/cheetah-turbo-themes/theme01.png');
        }

        &:nth-of-type(2) {
          background: url('../../../assets/images/cheetah-turbo-themes/theme02.png');
        }

        &:nth-of-type(3) {
          background: url('../../../assets/images/cheetah-turbo-themes/theme04.png');
        }

        &:nth-of-type(4) {
          background: url('../../../assets/images/cheetah-turbo-themes/theme05.png');
        }

        &:nth-of-type(5) {
          background: url('../../../assets/images/cheetah-turbo-themes/theme06.png');
        }

       
        

        &:hover {
          border: 2px dashed;
          border-color: #0080FC;
        }

        &.active {
          border: 2px dashed;
          border-color: #0080FC;
        }
      }
    }
  }

  &__separator {
    border-top: #D1D2D2 2px solid;
  }

  .card {

    &-header {
      font-family: 'Muli', sans-serif;
      font-size: 20px;
      font-weight: 600;
      text-transform: uppercase;

      color: #333333;
      background-color: #F7F7F7;

      box-shadow: 0px 6px 3px #7E7E7E10;
      padding: 24px 32px;
      z-index: 2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/CheetahTurboPage.vue